<template>
<div id="changelog">
  <div class="ContentContainer">
    <h1>Changelog</h1>

    <h3 class="heading-lined">Version 0.19</h3>
    <p>August, 2023</p>
    <ul class="list mb-5">
      <li>Removed Binance API to rebuild it more stable.</li>
    </ul>Version 0.19

    <h3 class="heading-lined">Version 0.18</h3>
    <p>March, 2022</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>Full Portfolio feature.</li>
    </ul>

    <h3 class="heading-lined">Version 0.17</h3>
    <p>June 1, 2021</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>When registering, don't need to add asset tracked when you were unregistered, it's fletched now.</li>
      <li>Japanese Translation / お知らせ！日本語の翻訳を追加しました.</li>
    </ul>

    <h3 class="heading-lined">Version 0.16</h3>
    <p>May 1, 2021</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>Spanish Translation.</li>
      <li>Auto reset for password.</li>
    </ul>

    <h3 class="heading-lined">Version 0.15</h3>
    <p>April 1, 2021</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>Every line of your assets is clickable to CMC for more information.</li>
      <li>Chinese Translation / 中文翻译 / 中文翻譯.</li>
    </ul>

    <h3 class="heading-lined">Version 0.14</h3>
    <p>March 15, 2021</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>Sorting of your assets is now memorized.</li>
      <li>Change color of your asset in the pie chart.</li>
    </ul>

    <h3 class="heading-lined">Version 0.13</h3>
    <p>February 24, 2021</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>Icons for all coins of your portfolio.</li>
      <li>Editing amount of your holdings right on homepage.</li>
    </ul>

    <h3 class="heading-lined">Version 0.12<span class="badge badge-info">beta</span></h3>
    <p>April 24, 2019</p>
    <p>New features</p>
    <ul class="list mb-5">
      <li>Nightmode (Enable or disable on Settings).</li>
      <li>French Translation (more languages to come).</li>
    </ul>

    <h3 class="heading-lined">Version 0.11<span class="badge badge-info">beta</span></h3>
    <p>January 4, 2019</p>
    <p>Major update, including code refactoring.</p>
    <ul class="list mb-5">
      <li>Refactored major parts of code.</li>
      <li>Changing currency is now faster.</li>
    </ul>

    <h3 class="heading-lined">Version 0.10<span class="badge badge-info">beta</span></h3>
    <p>January 7, 2018</p>
    <p>Minor update that brings some requested features as well as cosmetic changes and bug fixes.</p>
    <ul class="list mb-5">
      <li>Now you can create an account using email (located at the sign in -page).</li>
      <li>Added 18 new fiat currencies.</li>
      <li>Added FAQ -page.</li>
      <li>Changed CoinTrackr logo.</li>
      <li>Minor mobile UI rework.</li>
      <li>Fixed a bug with percentage calculations.</li>
      <li>Fixed a bug with assets that share the same symbol.</li>
    </ul>

    <h3 class="heading-lined">Version 0.9b<span class="badge badge-info">beta</span></h3>
    <p>Hotfix update.</p>
    <ul class="list mb-5">
      <li>Fixed a bug where it wasn't possible to add Bitcoin Gold as asset.</li>
    </ul>

    <h3 class="heading-lined">Version 0.9<span class="badge badge-info">beta</span></h3>
    <p>This updates brings some bug fixes and new features.</p>
    <ul class="list mb-5">
      <li>Fixed a problem where the chart was displayed too small.</li>
      <li>Added ability to sort by change in price in the last hour, day or week.</li>
      <li>Automatically sorted the chart and its labels by the %share of your portfolio.</li>
      <li>Changed some typos and changed "Evaluation" to "Valuation". 🙈</li>
    </ul>

    <h3 class="heading-lined">Version 0.8 <span class="badge badge-info">beta</span></h3>
    <p>This is a major update that brings sharing functionality and support for older browsers, among other fixes and improvements.</p>
    <ul class="list mb-5">
      <li>You can now create a public anonymous link for your portfolio.</li>
      <li>Internet Explorer 11+ and Safari 9+ are now supported.</li>
      <li>When assets don't have enough history you no longer see the <mark>NaN%</mark> error.</li>
      <li>Fixed a small bug that sometimes the prices would not update properly.</li>
      <li>Changed the incognito shortcut from <mark>C</mark> to 3x <mark>I</mark> (three times <mark>i</mark>).</li>
      <li>Fixes a bug that when an asset symbol changed and did not exist in the ticker data any more, not assets would be shown. This was needed as 3 currencies changes their symbols this week, namely <mark>ANS</mark> is now <mark>NEO</mark>, <mark>SEC</mark> is now <mark>SAFEX</mark> and finally, <mark>MYR</mark> is now <mark>XMY</mark>. Unfortunately you will have to re-add those assets manually.</li>
    </ul>

    <h3 class="heading-lined">Version 0.7 <span class="badge badge-info">beta</span></h3>
    <p>This brings an incognito mode, as well as more updates in interface and design.</p>
    <ul class="list mb-5">
      <li>A new incognito mode that hides all absolute numbers, to check it easily in public. You can enable and disable it with the <mark>C</mark> key. In this mode, you will also see the percentages of your assets displayed.</li>
      <li>The chart and the new portfolio widget are now sorted by the name of the coin.</li>
      <li>There are are now custom tooltips on the chart, giving you way more information.</li>
      <li>Prices are now displayed with a greater precision, e.g. 0.0132 or 0.000012 instead of 0.01 if necessary.</li>
      <li>The price of the unit is now switched around with the worth of the asset you own.</li>
      <li>Some bug fixes and general code improvements.</li>
    </ul>

    <h3 class="heading-lined">Version 0.6 <span class="badge badge-info">beta</span></h3>
    <p>This updates focuses on interface improvements and enables HTTPS/SSL.</p>
    <ul class="list mb-5">
      <li>Made modifications to the UI to clean it up and make it easier / more intuitive to use.</li>
      <li>Settings, sorting, currencies and authentication are now decoupled.</li>
      <li>We're also displaying who is logged in, so you can be sure what portfolio you are editing.</li>
      <li>Added more currencies with even more to follow up to version 1.0.</li>
      <li>Enforced SSL to encrypt the connection between you and CoinTrackr.</li>
      <li>Added Open Graph functionality for better sharing on Facebook, Telegram & co</li>
      <li>Fixed a variety of bugs and did some more restructuring of code for scalability.</li>
    </ul>

    <h3 class="heading-lined">Version 0.5c <span class="badge badge-info">beta</span></h3>
    <p>Hotfix update.</p>
    <ul class="list mb-5">
      <li>Found a way to re-enable social logins as a home screen app on iOS. If you have been using this feature in the past, you will have to delete and re-add the CoinTrackr app for this to work. Yay!</li>
    </ul>

    <h3 class="heading-lined">Version 0.5b <span class="badge badge-info">beta</span></h3>
    <p>Hotfix update.</p>
    <ul class="list mb-5">
      <li>Disabled signing in into the mobile standalone version which is not supported by Google.</li>
    </ul>

    <h3 class="heading-lined">Version 0.5 <span class="badge badge-info">beta</span></h3>
    <p>This update focuses on social logins and synchronizations of portfolios across multiple devices/browsers.</p>
    <ul class="list mb-5">
      <li>Added social login capabilities so you can synchronize your portfolio across your computer/s and phone/tablet.</li>
      <li>Added Swiss Francs (CHF) as a base currency.</li>
      <li>Added donation addresses for BTC and ETH, feel free to help me buy a Lambo!</li>
      <li>Added Terms & Conditions, Privacy Policy as well as a contact page.</li>
      <li>Fixed a variety of bugs and again refactored parts of the code.</li>
    </ul>

    <h3 class="heading-lined">Version 0.4 <span class="badge badge-info">beta</span></h3>
    <p>This version focuses on currency conversion and cleaner code overall.</p>
    <ul class="list mb-5">
      <li>Added base currency support for BTC, ETH, CAD, CNY, JPY, EUR, GBP and KRW.</li>
      <li>Changed the default behaviour of the valuation in the tab title bar to visible.</li>
      <li>Fixed a bug where the settings menu wouldn't close on mobile.</li>
      <li>Cleaned up the code considerably for easier improvements in the future!</li>
    </ul>

    <h3 class="heading-lined">Version 0.3 <span class="badge badge-info">beta</span></h3>
    <p>This version continues to focus on mobile optimizations.</p>
    <ul class="list mb-5">
      <li>Added functionality for iOS to behave like a real app if added to the home screen.</li>
      <li>Added feature that lets you know when the portfolio was last updated.</li>
      <li>Added feature to update the portfolio value in the title bar.</li>
      <li>Added favicon and Apple touch icon (for the home screen).</li>
      <li>Showing more columns in landscape mode on mobile.</li>
      <li>Settings menu now closes when clicked anywhere outside of it.</li>
      <li>Slightly adjusted the layout further on mobile to allow for more content.</li>
      <li>A few more smaller bugfixes and additions.</li>
    </ul>

    <h3 class="heading-lined">Version 0.2 <span class="badge badge-info">beta</span></h3>
    <p>Received loads of helpful feedback, thank you everybody!</p>
    <ul class="list mb-5">
      <li>Added mobile compatibility down to 4.7" screens (iPhone 6, Galaxy S, Pixel, etc)</li>
      <li>Fixed a bug where older browsers (e.g. Safari 10.2 and lower) failed to load the page.</li>
    </ul>

    <h3 class="heading-lined">Version 0.1 <span class="badge badge-info">beta</span></h3>
    <p>09 June 2017</p>
    <ul class="list">
      <li>Initial release!</li>
      <li>Manage your portfolio online and see profits/losses of your holdings.</li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: "Changelog",
  metaInfo: {
    title: "Changelog CoinTrackr", 
  },
};
</script>

<style lang="scss" scoped>
  h3 {
    font-size: 24px;
  }

  p {
    font-weight: 700;
    margin-bottom: 10px;
  }

  .badge {
    font-size: 16px;
    margin-left: 5px;
    vertical-align: middle;
  }
</style>
